<template>
  <section>
    <div class="download-box">
      <div class="title">
        <span>下面为客户端最近5次版本的更新记录，可选择合适的版本下载</span>
      </div>
      <div class="download-box-windows">
        <span class="download-box-title">Windows客户端</span>
        <div v-for="item in windowslist" :key="item.id">
          <div class="download-box-item">
            <img src="@/assets/download.jpg" class="img">
            <div class="item-content">
              <div class="item-content-date">
                <span>{{ item.updateTime|dateTime }}</span>
              </div>
              <div class="item-content-vresion">
                <span>版本：{{ item.appVersionName }}</span>
                <el-link type="primary" :underline="false" :href="item.url">
                  下载
                </el-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="download-box-mac">
        <span class="download-box-title">Mac客户端</span>
        <div v-for="item in macList" :key="item.id">
          <div class="download-box-item">
            <img src="@/assets/download.jpg" class="img">
            <div class="item-content">
              <div class="item-content-date">
                <span>{{ item.updateTime|dateTime }}</span>
              </div>
              <div class="item-content-vresion">
                <span>版本：{{ item.appVersionName }}</span>
                <el-link type="primary" :underline="false" :href="item.url">
                  下载
                </el-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  data() {
    return {
      windowslist: [], // windows客户端
      macList: [], // mac客户端
    };
  },
  computed: {},
  created() {
    this.getWindowsHistory();
    this.getMacHistory();
  },
  mounted() {

  },
  methods: {
    // 获取windows客户端历史版本------------------------------------------------------------------------------------------* */
    getWindowsHistory() {
      this.$api.getPrintClientHistory({
        appId: 'DfPcClientWindows', lastNum: 5,
      }).then((res) => {
        if (res.code === 0) {
          this.windowslist = res.data;
        }
      });
    },
    // 获取mac客户端历史版本------------------------------------------------------------------------------------------* */
    getMacHistory() {
      this.$api.getPrintClientHistory({
        appId: 'DfPcClientMac', lastNum: 5,
      }).then((res) => {
        if (res.code === 0) {
          this.macList = res.data;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.download-box{
  display: flex;
  flex-direction: column;
  margin-left: 120px;
  height: 1470px;
  .title{
  font-size: 20px;
  margin-top:52px ;
}
.download-box-windows{
  margin-top: 40px;
}
.download-box-title{
   height: 23px;
   opacity: 1;
   font-size: 20px;
   font-family: -700;
   font-weight: bold;
  }
.download-box-item{
  display: flex;
  .item-content{
    margin-top:53px ;
    margin-left: 23px;
  }
  }
.item-content-date{
      height: 16px;
      font-size: 18px;
      font-family: -400;
      font-weight: 400;
      margin-bottom:13px ;
    }
.item-content-vresion{
      margin-bottom:7px;
      height: 16px;
      font-family: -400;
      font-weight: 400;
      color: #7f7f7f;
    }

.download-box-mac{
  margin-top: 40px;
}
 .img{
  width: 37px;
  height: 37px;
  margin-top:52px ;
  }
  .el-link{
    margin-left: 19px;
  }
}

</style>
